var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssetsLoginLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 216,
    height: 39.563,
    viewBox: "0 0 216 39.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(2568.5 -798.836)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    transform: "translate(-2559.5 798.836)",
    fill: "#822973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M6.83,13.495A6.85,6.85,0,0,1,2,11.519,6.721,6.721,0,0,1,.537,9.374a6.695,6.695,0,0,1,0-5.253A6.721,6.721,0,0,1,2,1.976,6.9,6.9,0,0,1,9.32.463,6.82,6.82,0,0,1,11.4,1.733L8.823,4.224l0,0A1.481,1.481,0,0,0,10.4,6.7l0,.005.023-.017a1.475,1.475,0,0,0,.473-.353l2.393-1.787a6.69,6.69,0,0,1-1.63,6.97A6.85,6.85,0,0,1,6.83,13.495Z",
    transform: "translate(-2568.5 824.904)",
    fill: "#822973"
  }), /*#__PURE__*/React.createElement("text", {
    id: "OsstellConnect",
    "data-name": "OsstellConnect",
    fill: "#822973",
    stroke: "rgba(0,0,0,0)",
    transform: "translate(-2434.5 827.836)",
    strokeWidth: 1,
    fontSize: 28,
    fontFamily: "SourceSansPro-Light, Source Sans Pro",
    fontWeight: 300,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -80.542,
    y: 0
  }, "OsstellConnect")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsLoginLogo);
export default __webpack_public_path__ + "static/media/assets_login-logo.beb475cad67491127a46fb57154bf20c.svg";
export { ForwardRef as ReactComponent };